export default defineNuxtPlugin((nuxtApp) => {
  // Vue 앱 레벨 에러 핸들러
  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    console.group('%c⚠️ Vue 에러 발생', 'background: #ff6b6b; color: white; padding: 4px 8px; font-weight: bold;');

    console.log('%c에러 정보:', 'color: #e74c3c; font-weight: bold;');
    console.log('├─ Message:', error.message);
    console.log('├─ Name:', error.name);
    console.log('├─ Component:', instance?.$options?.name || instance?.$options?.__name || 'Unknown');
    console.log('├─ Info:', info);

    if (error.stack) {
      console.log('%c스택 트레이스:', 'color: #e74c3c; font-weight: bold;');
      console.log(error.stack);
    }

    console.log('%c전체 에러 객체:', 'color: #95a5a6; font-weight: bold;');
    console.log(error);

    console.groupEnd();

    // 에러를 상위로 전파하지 않고 여기서 처리
    // error.vue로 가지 않고 콘솔에만 로그를 남김
  };

  // unhandledrejection 이벤트 핸들러 (Promise rejection)
  if (typeof window !== 'undefined') {
    window.addEventListener('unhandledrejection', (event) => {
      console.group('%c⚠️ Unhandled Promise Rejection', 'background: #f39c12; color: white; padding: 4px 8px; font-weight: bold;');

      console.log('%c에러 정보:', 'color: #e67e22; font-weight: bold;');
      console.log('├─ Reason:', event.reason);
      console.log('├─ Promise:', event.promise);

      if (event.reason?.stack) {
        console.log('%c스택 트레이스:', 'color: #e67e22; font-weight: bold;');
        console.log(event.reason.stack);
      }

      console.groupEnd();

      // 기본 동작 방지 (error.vue로 가지 않음)
      event.preventDefault();
    });

    // error 이벤트 핸들러
    window.addEventListener('error', (event) => {
      console.group('%c⚠️ Global Error Event', 'background: #e74c3c; color: white; padding: 4px 8px; font-weight: bold;');

      console.log('%c에러 정보:', 'color: #c0392b; font-weight: bold;');
      console.log('├─ Message:', event.message);
      console.log('├─ Filename:', event.filename);
      console.log('├─ Line:', event.lineno);
      console.log('├─ Column:', event.colno);
      console.log('├─ Error:', event.error);

      if (event.error?.stack) {
        console.log('%c스택 트레이스:', 'color: #c0392b; font-weight: bold;');
        console.log(event.error.stack);
      }

      console.groupEnd();

      // 기본 동작 방지 (error.vue로 가지 않음)
      event.preventDefault();
    });
  }

  // Nuxt hook을 사용하여 에러를 가로채기
  nuxtApp.hook('vue:error', (error, instance, info) => {
    console.group('%c🔴 Nuxt Vue Error Hook', 'background: #9b59b6; color: white; padding: 4px 8px; font-weight: bold;');

    console.log('%c에러 정보:', 'color: #8e44ad; font-weight: bold;');
    console.log('├─ Error:', error);
    console.log('├─ Component:', instance?.$options?.name || instance?.$options?.__name || 'Unknown');
    console.log('├─ Info:', info);

    if (error.stack) {
      console.log('%c스택 트레이스:', 'color: #8e44ad; font-weight: bold;');
      console.log(error.stack);
    }

    console.groupEnd();
  });

  // app:error hook
  nuxtApp.hook('app:error', (error) => {
    console.group('%c🔴 Nuxt App Error Hook', 'background: #e91e63; color: white; padding: 4px 8px; font-weight: bold;');

    console.log('%c에러 정보:', 'color: #c2185b; font-weight: bold;');
    console.log('├─ Error:', error);

    if (error.stack) {
      console.log('%c스택 트레이스:', 'color: #c2185b; font-weight: bold;');
      console.log(error.stack);
    }

    console.groupEnd();
  });
});
